import { USER_LOGIN_SUCCESS, USER_LOGOUT } from '../constants';

export function logUser(data) {
  const action = {
    type: USER_LOGIN_SUCCESS,
    user: data.user,
    permissions: data.permissions
  }
  return action;
}

export function logout() {
  const action = {
    type: USER_LOGOUT
  }
  return action;
}


// WEBPACK FOOTER //
// ./src/actions/index.js